import { CircleBackground } from ".//CircleBackground";
import { Container } from ".//Container";
import { Button } from "./Button";

export function CallToAction() {
  return (
    <section
      id="get-free-shares-today"
      className="relative overflow-hidden bg-mm-light-rose py-20 sm:py-28"
    >
      <div className="absolute top-1/2 left-20 -translate-y-1/2 sm:left-1/2 sm:-translate-x-1/2">
        <CircleBackground color="#b297b4" className="animate-spin-slower" />
      </div>
      <Container className="relative">
        <div className="mx-auto max-w-md sm:text-center">
          <h2 className="text-3xl font-medium tracking-tight text-mm-purple sm:text-4xl">
            Lige nu kan du få hele forløbet for kun 29 kr. om måneden
          </h2>
          <p className="mt-4 text-lg text-black">
            Vi drypper indholdet til dig i takt med, at din graviditet skrider
            frem. Vi tror på, at viden skal komme lidt ad gangen, diskuteres og
            synke ned. Det skaber en rolig og tryg graviditet.
          </p>
          <div className="mt-8 flex justify-center">
            <Button variant="solid" href="/get-started">
              Kom i gang for 29 kr. (for evigt)
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
}
